import { GetOrganizationsListResponseBodyType } from "@intelligems/ig-types/functions/organizations-list/get-organizations-list";
import { orgListKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

export const getOrgList = async () => {
  const [installed, uninstalled] = await Promise.all([
    api.get<GetOrganizationsListResponseBodyType>(
      `/v2/organizations-list?isInstalled=true`
    ),
    api.get<GetOrganizationsListResponseBodyType>(
      `/v2/organizations-list?isInstalled=false`
    ),
  ]);
  return {
    orgs: [...(installed.data.orgs ?? []), ...(uninstalled.data.orgs ?? [])],
  };
};

export const useGetOrgList = () => {
  return useQuery<GetOrganizationsListResponseBodyType, Error>({
    queryKey: orgListKeys.all,
    queryFn: async () => getOrgList(),
  });
};

export const getInstalledOrgList = async () => {
  const resp = await api.get<GetOrganizationsListResponseBodyType>(
    `/v2/organizations-list?isInstalled=true`
  );
  return resp.data;
};

export const useGetInstalledOrgList = () => {
  return useQuery<GetOrganizationsListResponseBodyType, Error>({
    queryKey: [...orgListKeys.all, "installed"],
    queryFn: async () => getInstalledOrgList(),
  });
};
